var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "w-header-modal" }, [
        _c("div", { staticClass: "w-header-modal-mask" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "w-header-modal-wrap",
            style: { width: _vm.width + "px" }
          },
          [
            _c("div", { staticClass: "w-header-modal-header" }, [
              _c("div", { staticClass: "w-header-modal-header-inner" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "w-header-modal-header-close",
                  on: { click: _vm.closeModal }
                },
                [_vm._v("＋")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-header-modal-main", class: _vm.mainName },
              [_vm._t("modal-main")],
              2
            ),
            _vm._v(" "),
            _vm.footerFlg
              ? _c("div", { staticClass: "w-header-modal-footer" }, [
                  _vm.cancelFlg
                    ? _c(
                        "button",
                        {
                          staticClass: "w-header-modal-cancle",
                          on: { click: _vm.cancel }
                        },
                        [_vm._v(_vm._s(_vm.cancelText))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.okFlg
                    ? _c(
                        "button",
                        {
                          staticClass: "w-header-modal-ok",
                          on: { click: _vm.ok }
                        },
                        [_vm._v(_vm._s(_vm.okText))]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37070633", { render: render, staticRenderFns: staticRenderFns })
  }
}